import { IOpenMenuAction, IOpenNewTemplateAction, IReloadListAction, IShowSnackbarAction, ISnackbar } from './types';

export const openMenuAction = (openMenu:boolean):IOpenMenuAction => ({
  type: "OPEN_MENU",
  payload: openMenu
})

export const openNewTemplateAction = (openNewTemplate:boolean):IOpenNewTemplateAction => ({
  type: "OPEN_NEW_TEMPLATE",
  payload: openNewTemplate
})

export const reloadListAction = (reloadList:boolean):IReloadListAction => ({
  type: "RELOAD_LIST",
  payload: reloadList
})

export const showSnackBarAction = (snackbar: ISnackbar):IShowSnackbarAction => ({
  type: "SHOW_SNACKBAR",
  snackbar: snackbar
})

